import { CanConsumptionMessages, TranslationCanConsumptionMessages } from "../interfaces/canConsumptionMessages";

const canConsumptionMessages: TranslationCanConsumptionMessages = {
  [CanConsumptionMessages.menu]: "Telemetría CAN",
  [CanConsumptionMessages.title]: "Telemetría CAN",
  [CanConsumptionMessages.tabDashboard]: "Panel",
  [CanConsumptionMessages.tabSyntheticReport]: "Informe sintético",
  [CanConsumptionMessages.tabAnalyticReport]: "Informe analítico",
  [CanConsumptionMessages.tabGraph]: "Gráfico CAN",

  [CanConsumptionMessages.volumeCarriedColumn]: "Volumen Transportado (m³)",

  [CanConsumptionMessages.filterPeriod]: "Período de análisis",
  [CanConsumptionMessages.filterPreset7Days]: "Últimos 7 días",
  [CanConsumptionMessages.filterPreset3Days]: "Últimos 3 días",
  [CanConsumptionMessages.filterPreset1Day]: "Último día",
  [CanConsumptionMessages.filterPresetCustom]: "Personalizado",
  [CanConsumptionMessages.filterDateFrom]: "Desde",
  [CanConsumptionMessages.filterDateTo]: "hasta",
  [CanConsumptionMessages.filterPlants]: "Central",
  [CanConsumptionMessages.filterVehicleTypes]: "Tipo de equipo",
  [CanConsumptionMessages.filterAllVehicleTypes]: "Todos",
  [CanConsumptionMessages.filterAlertLimits]: "Límites de alerta",
  [CanConsumptionMessages.filterPlantsPlural]: "Centrales",
  [CanConsumptionMessages.filterVehicleTypesPlural]: "Tipos de equipo",

  [CanConsumptionMessages.periodSummary]: "{{vehicles}} equipos · {{travels}} viajes",
  [CanConsumptionMessages.periodConsolidatingWarning]:
    "El período termina en días que aún se están consolidando: la integración de las facturas tarda 1 o 2 días y el volumen de esos días todavía "
    + "puede subir.",
  [CanConsumptionMessages.periodNoData]: "No hay datos de consumo para el período y los filtros seleccionados.",

  [CanConsumptionMessages.metricLitersPerM3Label]: "Consumo medio por m³",
  [CanConsumptionMessages.metricLitersPerM3Short]: "Consumo por m³",
  [CanConsumptionMessages.metricLitersPerM3Unit]: "L/m³",
  [CanConsumptionMessages.metricKmPerLiterLabel]: "Kilómetros por litro",
  [CanConsumptionMessages.metricKmPerLiterShort]: "KM por litro",
  [CanConsumptionMessages.metricKmPerLiterUnit]: "km/L",
  [CanConsumptionMessages.metricLitersPerTravelLabel]: "Consumo medio por viaje",
  [CanConsumptionMessages.metricLitersPerTravelShort]: "Consumo por viaje",
  [CanConsumptionMessages.metricLitersPerTravelUnit]: "L/viaje",
  [CanConsumptionMessages.metricLitersPerHourLabel]: "Consumo medio por hora",
  [CanConsumptionMessages.metricLitersPerHourShort]: "Consumo por hora",
  [CanConsumptionMessages.metricLitersPerHourUnit]: "L/h",
  [CanConsumptionMessages.metricIdleLitersPerHourLabel]: "Ralentí",
  [CanConsumptionMessages.metricIdleLitersPerHourShort]: "Ralentí",
  [CanConsumptionMessages.metricIdleLitersPerHourUnit]: "L/h",
  [CanConsumptionMessages.hintLowerIsBetter]: "cuanto menor, mejor",
  [CanConsumptionMessages.hintHigherIsBetter]: "cuanto mayor, mejor",

  [CanConsumptionMessages.zoneOk]: "dentro del límite",
  [CanConsumptionMessages.zoneWarn]: "en franja de atención",
  [CanConsumptionMessages.zoneCritical]: "por encima del límite crítico",
  [CanConsumptionMessages.gaugeThresholds]: "atención {{warn}} · crítico {{critical}}",
  [CanConsumptionMessages.gaugeNoData]: "sin datos en el filtro actual",

  [CanConsumptionMessages.tileVolume]: "Volumen transportado",
  [CanConsumptionMessages.tileVolumeFoot]: "{{travels}} viajes en el período",
  [CanConsumptionMessages.tileFuel]: "Combustible consumido",
  [CanConsumptionMessages.tileFuelFoot]: "{{distance}} km recorridos",
  [CanConsumptionMessages.tileFuelInside]: "Combustible dentro de los viajes",
  [CanConsumptionMessages.tileFuelInsideFoot]: "{{percent}}% del total",
  [CanConsumptionMessages.tileFuelBetween]: "Combustible entre viajes",
  [CanConsumptionMessages.tileFuelBetweenFoot]: "todo el consumo fuera del viaje · {{percent}}% del total",
  [CanConsumptionMessages.tileFuelBetweenHint]: "Medido por el contador del propio vehículo, desde el fin de un viaje "
    + "hasta el inicio del siguiente — sin filtro de lugar ni de velocidad. Entra todo lo quemado fuera del viaje: "
    + "ralentí y espera en el patio, retorno vacío, abastecimiento, mantenimiento y cualquier otro desplazamiento. Con "
    + "filtro por central, cada intervalo se atribuye a la central del viaje siguiente.",
  [CanConsumptionMessages.tileHoursBetween]: "Motor encendido entre viajes",
  [CanConsumptionMessages.tileHoursBetweenFoot]: "{{idle}} en ralentí",
  [CanConsumptionMessages.tileHoursBetweenHint]: "Tiempo con el motor funcionando fuera del viaje — la regla de "
    + "los litros de al lado. Cero aquí es medición, no ausencia: significa que la flota apagó el motor en el patio.",
  [CanConsumptionMessages.tileAvgKmPerTravel]: "Distancia media por viaje",
  [CanConsumptionMessages.tileAvgKmPerTravelFoot]: "odómetro CAN de los viajes del período",
  [CanConsumptionMessages.tileAvgSpeed]: "Velocidad media",
  [CanConsumptionMessages.tileAvgSpeedFoot]: "media ponderada por viaje",
  [CanConsumptionMessages.tileAvgTravelTime]: "Tiempo medio por viaje",
  [CanConsumptionMessages.tileAvgTravelTimeFoot]: "de la salida de la central al fin del viaje",
  [CanConsumptionMessages.tileAttention]: "Equipos en atención",
  [CanConsumptionMessages.tileAttentionFoot]: "por encima del límite de {{metric}}",

  [CanConsumptionMessages.rankingTitle]: "Ranking por vehículo",
  [CanConsumptionMessages.rankingSubtitle]: "Cada barra es un vehículo. La línea marca la mediana de la flota.",
  [CanConsumptionMessages.rankingMetricLabel]: "Indicador del ranking",
  [CanConsumptionMessages.rankingFallbackNote]: "sin datos de {{metric}} en este filtro — mostrando {{fallback}}",
  [CanConsumptionMessages.rankingEmpty]: "Sin datos de {{metric}} para el filtro actual.",

  [CanConsumptionMessages.dailyTitle]: "Día a día",
  [CanConsumptionMessages.dailySubtitle]: "Volumen transportado por día y el consumo medio correspondiente.",
  [CanConsumptionMessages.dailyFoot]: "Barras: {{bars}} · números: {{metric}} ({{unit}})",
  [CanConsumptionMessages.dailyBarsVolume]: "volumen transportado (m³)",
  [CanConsumptionMessages.dailyBarsFuel]: "combustible (L)",
  [CanConsumptionMessages.dailyNoOperation]: "sin operación",
  [CanConsumptionMessages.dailyConsolidating]: "aún consolidando",
  [CanConsumptionMessages.dailyConsolidatingLegend]:
    "Día rayado: aún consolidando. La integración de las facturas tarda 1 o 2 días, así que el volumen del día todavía puede subir y el consumo "
    + "por m³ aparece inflado.",

  [CanConsumptionMessages.plantsTitle]: "Consumo por central",
  [CanConsumptionMessages.plantsSubtitle]:
    "Cada viaje pertenece a la central donde cargó; cuando no sale de una usina, a la central de asignación del vehículo. "
    + "El combustible entre viajes sigue al viaje siguiente.",
  [CanConsumptionMessages.plantsNoPlantRow]: "Sin central",
  [CanConsumptionMessages.columnPlant]: "Central",

  [CanConsumptionMessages.tableTitle]: "Desempeño por vehículo",
  [CanConsumptionMessages.columnVehicle]: "Vehículo",
  [CanConsumptionMessages.columnVehicleType]: "Tipo",
  [CanConsumptionMessages.columnPlants]: "Centrales",
  [CanConsumptionMessages.columnTravels]: "Viajes",
  [CanConsumptionMessages.columnVolume]: "Volumen transportado (m³)",
  [CanConsumptionMessages.columnDistance]: "Distancia (km)",
  [CanConsumptionMessages.columnFuel]: "Combustible (L)",
  [CanConsumptionMessages.columnAvgKmPerTravel]: "Distancia media (km/viaje)",
  [CanConsumptionMessages.columnAvgSpeed]: "Velocidad media (km/h)",
  [CanConsumptionMessages.columnAvgTravelTime]: "Tiempo medio (h:mm)",
  [CanConsumptionMessages.tableLowSample]: "pocos viajes",
  [CanConsumptionMessages.tableEmpty]: "Ningún equipo para el período y los filtros seleccionados.",
  [CanConsumptionMessages.legendBest]: "Mejor",
  [CanConsumptionMessages.legendWorst]: "Peor",
  [CanConsumptionMessages.legendHigherIsBetter]: "En KM por litro, cuanto mayor es el número, mejor.",
  [CanConsumptionMessages.legendNoColor]:
    "Celda sin color: sin datos en el período o menos de {{minTravels}} viajes — una base pequeña no entra en ranking ni en alertas.",

  [CanConsumptionMessages.limitsTitle]: "Límites de alerta",
  [CanConsumptionMessages.limitsSubtitle]:
    "Defina, para cada indicador, a partir de qué valor un vehículo merece atención. Las franjas de los indicadores y los colores de la tabla "
    + "siguen estos límites.",
  [CanConsumptionMessages.limitsWarn]: "Atención",
  [CanConsumptionMessages.limitsCritical]: "Crítico",
  [CanConsumptionMessages.limitsFleetMedian]: "mediana de la flota {{value}}",
  [CanConsumptionMessages.limitsReset]: "Restaurar valores predeterminados",
  [CanConsumptionMessages.limitsDone]: "Concluir",
  [CanConsumptionMessages.limitsClose]: "Cerrar"
};

export const messages = canConsumptionMessages;
